import snakeCase from 'lodash/snakeCase'
import { useIntl } from 'react-intl'
import { PRODUCT_TYPE_GIFTCARD } from '../constants'

/**
 * @description This hook returns the product options for a given product.
 *
 * If the product is a gift card, it will return the gift card options translated.
 * @param {Object} item - Product item
 */
export const useItemProductOptions = ({ type, metadata, productOptions }) => {
	const { formatMessage } = useIntl()

	if (type === PRODUCT_TYPE_GIFTCARD) {
		const giftcardOptions = { ...metadata?.giftcardOptions }

		// if amount is set, delete the open amount option
		if (giftcardOptions.amount) delete giftcardOptions.openAmount
		// else if open amount is set, delete the amount option
		else delete giftcardOptions.amount

		return Object.entries(giftcardOptions)?.map(([optionName, value]) => ({
			label: formatMessage({ id: snakeCase(`${type}_${optionName}`) }),
			value,
		}))
	} else {
		return productOptions
	}
}
